import { render, staticRenderFns } from "./ResumoGemeos.vue?vue&type=template&id=300b0a15&"
import script from "./ResumoGemeos.vue?vue&type=script&lang=js&"
export * from "./ResumoGemeos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports